/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { CommentListForMonitoring } from '../../models/comment-list-for-monitoring';

export interface CommentControllerGetAll$Params {
  monitoringId: number;
  skip?: number;
  take?: number;
}

export function commentControllerGetAll(http: HttpClient, rootUrl: string, params: CommentControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CommentListForMonitoring;
}>> {
  const rb = new RequestBuilder(rootUrl, commentControllerGetAll.PATH, 'get');
  if (params) {
    rb.path('monitoringId', params.monitoringId, {});
    rb.query('skip', params.skip, {});
    rb.query('take', params.take, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: CommentListForMonitoring;
      }>;
    })
  );
}

commentControllerGetAll.PATH = '/monitoring/{monitoringId}/comments';
